import { FACEBOOK_MACHINE_NAME, SNAP_MACHINE_NAME, TIKTOK_SAN_MACHINE_NAME } from '../constants/adPartnerConstants';

/**
 * Returns true if deeplink_no_attribution should be applied for specific ad partner template params
 *
 * @param {string} partnerName - 3p name of ad partner
 */
export const isDeeplinkNoAttributionPartner = (partnerName?: string): boolean => {
  switch (partnerName) {
    case SNAP_MACHINE_NAME:
    case FACEBOOK_MACHINE_NAME:
    case TIKTOK_SAN_MACHINE_NAME:
      return true;
    default:
      return false;
  }
};
